import React from "react";
import { Link } from "react-router-dom";
import { NavLinkProps } from "../../types";

export const NavLink: React.FC<NavLinkProps & { onClick?: () => void }> = ({
  text,
  url,
  external,
  handleExternalRedirect,
  onClick,
}) => {
  const handleClick = () => {
    if (external) {
      handleExternalRedirect(url);
    }
    if (onClick) {
      onClick();
    }
  };

  if (external) {
    return (
      <button
        onClick={handleClick}
        className="hover:text-gray-600 dark:hover:text-gray-300"
      >
        {text}
      </button>
    );
  }

  return (
    <Link
      to={url}
      onClick={onClick}
      className="hover:text-gray-600 dark:hover:text-gray-300"
    >
      {text}
    </Link>
  );
};